import { render, staticRenderFns } from "./createWorkTeacherForm.vue?vue&type=template&id=519d5386&scoped=true&"
import script from "./createWorkTeacherForm.vue?vue&type=script&lang=js&"
export * from "./createWorkTeacherForm.vue?vue&type=script&lang=js&"
import style0 from "./createWorkTeacherForm.vue?vue&type=style&index=0&id=519d5386&prod&lang=less&scoped=true&"
import style1 from "./createWorkTeacherForm.vue?vue&type=style&index=1&id=519d5386&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d5386",
  null
  
)

export default component.exports